const getters = {
    isLoading: state => state.loading.isLoading,
    device: state => state.app.device,
    studentId: state => state.userInfo != null? state.userInfo.id : "",
    name: state => state.userInfo != null? state.userInfo.name : "",
    prepareList: state => state.lesson.prepareList,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js